import * as yup from 'yup';
import { REGEX_PATTERNS } from '@constants';

const validationSchema = yup.object().shape({
  customFields: yup.object().shape({
    phoneNumber: yup
      .string()
      .nullable()
      .notRequired()
      .matches(REGEX_PATTERNS.Phone, 'Invalid phone')
      .transform((value) => (value === '' ? null : value)),
  }),
});

export default validationSchema;
